export default {
  id: "autoecole",
  brandIcon: "🚕",
  defaultModule: "acceuil",
  footerNote: "Taxi ERP · Fleet Suite",
};
